let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("auTT6")).then(() => parcelRequire('29ZX6'));